var moduleMap = {
	"./Header": () => {
		return Promise.all([__webpack_require__.e(2934), __webpack_require__.e(1576), __webpack_require__.e(4915)]).then(() => (() => ((__webpack_require__(4915)))));
	},
	"./FeedbackPage": () => {
		return Promise.all([__webpack_require__.e(2934), __webpack_require__.e(7308)]).then(() => (() => ((__webpack_require__(7308)))));
	},
	"./BaseServices": () => {
		return Promise.all([__webpack_require__.e(9089), __webpack_require__.e(8657)]).then(() => (() => ((__webpack_require__(8657)))));
	},
	"./useJobPolling": () => {
		return Promise.all([__webpack_require__.e(9089), __webpack_require__.e(4000)]).then(() => (() => ((__webpack_require__(4000)))));
	},
	"./CpcJourney": () => {
		return __webpack_require__.e(1949).then(() => (() => ((__webpack_require__(1949)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});